import * as Yup from 'yup';
import { useSnackbar } from 'notistack5';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, FormikProvider, useFormik } from 'formik';
import { Icon } from '@iconify/react';
// material
import {
  Box,
  Grid,
  Card,
  Stack,
  Switch,
  TextField,
  FormControlLabel,
  Typography,
  FormHelperText,
  MenuItem
} from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
// hooks
import useAuth from '../../../../hooks/useAuth';
import useIsMountedRef from '../../../../hooks/useIsMountedRef';
import { UploadAvatar } from '../../../upload';
// utils
import { fData } from '../../../../utils/formatNumber';
import apiUser from '../../../../api/user';
import { objectID } from '../../../../utils/objectID';
import { useDispatch } from '../../../../redux/store';
import { InitJanus } from '../../../../redux/slices/janus';
import jwtDecode from 'jwt-decode';

// ----------------------------------------------------------------------

export default function SettingGeneral({ userInfo, onClose }) {
  const PRIORITIZES = [
    {
      level: 'online',
      level_name: "Đang hoạt động"
    },
    {
      level: 'away',
      level_name: "Vắng mặt"
    },
  ];

  const isMountedRef = useIsMountedRef();
  const { enqueueSnackbar } = useSnackbar();
  const { user, updateProfile } = useAuth();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const UpdateUserSchema = Yup.object().shape({

  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      full_name: userInfo ? userInfo.full_name : '',
      email: userInfo ? userInfo.email : '',
      phone: userInfo ? userInfo.phone : '',
      address: userInfo ? userInfo.address : '',
      about: userInfo ? userInfo.about : '',
      status_temp: userInfo ? userInfo?.status_temp : ''
    },

    validationSchema: UpdateUserSchema,
    onSubmit: async (values, { setErrors, setSubmitting }) => {
      try {
        values.id = objectID(userInfo._id);
        const res = await apiUser.edit_info_profile(values);
        if (res.status == 200) {
          enqueueSnackbar("Cập nhật thông tin thành công !", { variant: 'success' });
          window.localStorage.setItem('accessToken', res.data.data);
          const user = jwtDecode(res.data.data);
          dispatch(InitJanus({ ipSip: user.ipPBX, sip: user.sipNumber, secret: user.sipPassword }))
          onClose();
        }
      } catch (error) {
        enqueueSnackbar(error.response.data.message[0], { variant: 'error' });
        setSubmitting(false);
        setErrors(error);
      }
    }
  });

  const { values, errors, touched, isSubmitting, handleSubmit, getFieldProps, setFieldValue } = formik;

  const handleDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file) {
        setFieldValue('photoURL', {
          ...file,
          preview: URL.createObjectURL(file)
        });
      }
    },
    [setFieldValue]
  );
  const handleChangePrioritize = (event) => {
    setFieldValue(event.target.name, event.target.value)
  };
  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        {/* <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Card sx={{ py: 10, px: 3, textAlign: 'center' }}>
              <UploadAvatar
                accept="image/*"
                file={values.photoURL}
                maxSize={3145728}
                onDrop={handleDrop}
                error={Boolean(touched.photoURL && errors.photoURL)}
                caption={
                  <Typography
                    variant="caption"
                    sx={{
                      mt: 2,
                      mx: 'auto',
                      display: 'block',
                      textAlign: 'center',
                      color: 'text.secondary'
                    }}
                  >
                    Allowed *.jpeg, *.jpg, *.png, *.gif
                    <br /> max size of {fData(3145728)}
                  </Typography>
                }
              />

              <FormHelperText error sx={{ px: 2, textAlign: 'center' }}>
                {touched.photoURL && errors.photoURL}
              </FormHelperText>

            </Card>
          </Grid>

          <Grid item xs={12} md={8}>
            <Card sx={{ p: 3 }}>
              <Stack spacing={{ xs: 2, md: 3 }}>
                <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
                  <TextField fullWidth label={t('name')} {...getFieldProps('full_name')} InputProps={{ readOnly: true, disableunderline: "true", style: { pointerEvents: "none" } }} />
                  <TextField fullWidth label={t('email_address')} {...getFieldProps('email')} InputProps={{ readOnly: true, disableunderline: "true", style: { pointerEvents: "none" } }} />
                </Stack>
                <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
                  <TextField fullWidth label={t('phone_number')} {...getFieldProps('phone')} />
                  <TextField fullWidth label={t('address')} {...getFieldProps('address')} />
                </Stack>
                <TextField {...getFieldProps('about')} fullWidth multiline minRows={4} maxRows={4} label={t('about')} />

              </Stack>
              <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
                <LoadingButton startIcon={<Icon icon="codicon:save-as" />} type="submit" variant="contained" loading={isSubmitting}>
                  {t('save_changes')}
                </LoadingButton>
              </Box>
            </Card>
          </Grid>
        </Grid> */}
        <Card sx={{ p: 3 }}>
          <Stack spacing={{ xs: 2, md: 3 }}>
            <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
              {/* <TextField fullWidth label={t('name')} {...getFieldProps('full_name')} InputProps={{ readOnly: true, disableunderline: "true", style: { pointerEvents: "none" } }} /> */}
              <TextField fullWidth label={t('name')} {...getFieldProps('full_name')} />
              <TextField fullWidth label={t('email_address')} {...getFieldProps('email')} InputProps={{ readOnly: true, disableunderline: "true", style: { pointerEvents: "none" } }} />
            </Stack>
            <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
              <TextField fullWidth label={t('phone_number')} {...getFieldProps('phone')} />
              <TextField fullWidth label={t('address')} {...getFieldProps('address')} />
            </Stack>
            <TextField {...getFieldProps('about')} fullWidth multiline minRows={4} maxRows={4} label={t('about')} />
            <TextField
              size='small'
              variant='outlined'
              fullWidth
              select
              value={values.status_temp}
              name='status_temp'
              onChange={handleChangePrioritize}
              sx={{
                '& svg': { display: 'none' },
                // '& fieldset': { display: 'none' },
                '& .MuiSelect-select': { justifyContent: "center", display: 'flex', alignItems: 'center' }
              }}
              error={Boolean(touched.status_temp && errors.status_temp)}
              helperText={touched.status_temp && errors.status_temp}
            >
              {PRIORITIZES.map((option) => (
                <MenuItem key={option} value={option.level}>
                  <Box
                    sx={{
                      mr: 1,
                      width: 14,
                      height: 14,
                      borderRadius: 0.5,
                      bgcolor: 'error.main',
                      ...(option.level === 'online' && { bgcolor: 'succ.main' }),
                      ...(option.level === 'medium' && { bgcolor: 'warning.main' })
                    }}
                  />
                  <Typography variant="body2" sx={{ textTransform: 'capitalize' }}>
                    {option.level_name}
                  </Typography>
                </MenuItem>
              ))}
            </TextField>
          </Stack>
          <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}>
            <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
              <LoadingButton startIcon={<Icon icon="codicon:save-as" />} type="submit" variant="contained" color="secondary" loading={isSubmitting}>
                Cập nhật
              </LoadingButton>
              <LoadingButton startIcon={<Icon icon="pajamas:cancel" />} variant="contained" color="error" onClick={() => onClose()}>
                Đóng
              </LoadingButton>
            </Stack>
          </Box>
        </Card>
      </Form>
    </FormikProvider>
  );
}
